import React, { useState } from 'react';
import Title from 'components/UI/Title';
import { connect } from 'react-redux';
import Row from 'components/UI/Layout/Row';
import PropTypes from 'prop-types';
import { buildAuthTravelAgencySelector } from 'store/selectors/travelAgency.selector';

function TravelAgency({ authTravelAgency })
{
    const [travelAgency] = useState(authTravelAgency);

    const travelAgencyAccountValues = (index) => travelAgency.parent_id === null ? travelAgency[index] : travelAgency.parent[index];

    return (
        <div className="tw-bg-white dark:tw-bg-neutral-900 tw-rounded tw-p-3 tw-mb-6">
            <Row>
                <Title displayLabel="Travel Agency" before title={travelAgency.name ?? ''} type="secondary" padding="tw-pt-0 tw-pl-5" />
            </Row>

            <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4">
                <div className="tw-flex tw-flex-1 tw-flex-col">
                    <div className="tw-flex tw-flex-wrap tw-gap-5 tw-ml-8">
                        <div className="tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5 before:content-[''] before:tw-absolute before:tw-w-[1px] before:tw-h-[100%] before:tw-top-[0%] before:tw-right-0 before:tw-bg-primary-default tw-relative">
                            <div className="tw-flex tw-items-end">
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">Country</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.country}</p>
                                </div>
                            </div>
                            <div className="tw-flex tw-items-end">
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">State</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.state}</p>
                                </div>
                            </div>
                            <div className="tw-flex tw-flex-col tw-text-xs">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">City</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.city}</p>
                            </div>
                            <div className="tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5">
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">Address</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.address}</p>
                                </div>
                            </div>
                            <div className="tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5">
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">ZIP Code</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.zip}</p>
                                </div>
                            </div>
                        </div>
                        <div className="tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5 before:content-[''] before:tw-absolute before:tw-w-[1px] before:tw-h-[100%] before:tw-top-[0%] before:tw-right-0 before:tw-bg-primary-default tw-relative">
                            {travelAgencyAccountValues('IATA') && travelAgencyAccountValues('IATA') !== '0' && (
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">IATA</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgencyAccountValues('IATA')}</p>
                                </div>
                            )}
                            {travelAgencyAccountValues('ARC') && travelAgencyAccountValues('ARC') !== '0' && (
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">ARC</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgencyAccountValues('ARC')}</p>
                                </div>
                            )}
                            {travelAgencyAccountValues('CLIA') && travelAgencyAccountValues('CLIA') !== '0' && (
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">CLIA</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgencyAccountValues('CLIA')}</p>
                                </div>
                            )}
                            {travelAgencyAccountValues('TRUE') && travelAgencyAccountValues('TRUE') !== '0' && (
                                <div className="tw-flex tw-flex-col tw-text-xs">
                                    <p className="tw-font-bold tw-text-black dark:tw-text-white">TRUE</p>
                                    <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgencyAccountValues('TRUE')}</p>
                                </div>
                            )}
                        </div>
                        <div className="tw-min-w-[200px] tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5 before:content-[''] before:tw-absolute before:tw-w-[1px] before:tw-h-[100%] before:tw-top-[0%] before:tw-right-0 before:tw-bg-primary-default tw-relative">
                            <div className="tw-flex tw-flex-col tw-text-xs">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">Logo</p>
                                <img src={travelAgency.logo} alt="Logo" className="tw-w-full tw-h-[100px] tw-object-contain" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tw-max-w-none tw-flex tw-flex-col tw-flex-1 xl:tw-max-w-[400px] lg:tw-max-w-[300px]">
                    <Row className="tw-mb-3">
                        <Title title="Accounting Information" margin="tw-mt-0 tw-mb-0" />
                        {/*
                        <div className="tw-flex tw-align-middle tw-justify-center">
                             {isEditable && (
                                <Button
                                    onClick={() =>
                                    {
                                        startEditing('accounting');
                                    }}
                                    margin="tw-mt-2 tw-ml-2"
                                    padding="tw-px-3 tw-py-1"
                                    type="primary"
                                    className="tw-self-center"
                                >
                                    Edit
                                </Button>
                            )}
                        </div>
                        */}
                    </Row>
                    <div className="tw-flex tw-px-7 tw-py-5 tw-gap-2 tw-justify-between tw-bg-[#E6E6E6] tw-rounded-md dark:tw-bg-zinc-700 ">
                        <div className='tw-flex tw-flex-col tw-w-[50%] tw-gap-6 before:content-[""] before:tw-absolute before:tw-w-[1px] before:tw-h-[100%] before:tw-top-[0%] before:tw-right-0 before:tw-bg-primary-default tw-relative'>
                            <div className="tw-flex tw-flex-col tw-text-xs tw-pr-3">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">Beneficiary Name</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.beneficiary_name ?? '(empty)'}</p>
                            </div>
                            <div className="tw-flex tw-flex-col tw-text-xs tw-pr-3">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">Tax ID</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.tax_id ?? '(empty)'}</p>
                            </div>
                            <div className="tw-flex tw-flex-col tw-text-xs tw-pr-3">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">ABA/Routing Number</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.routing_number ?? '(empty)'}</p>
                            </div>
                            <div className="tw-flex tw-flex-col tw-text-xs tw-pr-3">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">Account Number</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.account_number ?? '(empty)'}</p>
                            </div>
                        </div>
                        <div className="tw-flex tw-flex-col tw-w-[50%] tw-gap-6">
                            <div className="tw-flex tw-flex-col tw-text-xs">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">Bank Name</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.bank_name ?? '(empty)'}</p>
                            </div>
                            <div className="tw-flex tw-flex-col tw-text-xs">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">Bank Address</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.bank_address ?? '(empty)'}</p>
                            </div>
                            <div className="tw-flex tw-flex-col tw-text-xs">
                                <p className="tw-font-bold tw-text-black dark:tw-text-white">SWIFT Code</p>
                                <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{travelAgency.swift_code ?? '(empty)'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

TravelAgency.propTypes = {
    authTravelAgency: PropTypes.shape({
        parent: PropTypes.shape({
            parent_id: PropTypes.number,
            name: PropTypes.string,
            IATA: PropTypes.string,
            ARC: PropTypes.string,
            CLIA: PropTypes.string,
            TRUE: PropTypes.string,
            country: PropTypes.string,
            website: PropTypes.string,
            state: PropTypes.string,
            city: PropTypes.string,
            address: PropTypes.string,
            beneficiary_name: PropTypes.string,
            tax_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            routing_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            account_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            bank_name: PropTypes.string,
            bank_address: PropTypes.string,
            swift_code: PropTypes.string,
        }),
        parent_id: PropTypes.number,
        name: PropTypes.string,
        IATA: PropTypes.string,
        ARC: PropTypes.string,
        CLIA: PropTypes.string,
        TRUE: PropTypes.string,
        country: PropTypes.string,
        website: PropTypes.string,
        state: PropTypes.string,
        city: PropTypes.string,
        address: PropTypes.string,
        beneficiary_name: PropTypes.string,
        tax_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        routing_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        account_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        bank_name: PropTypes.string,
        bank_address: PropTypes.string,
        swift_code: PropTypes.string,
    }),
};

const mapStateToProps = () =>
{
    const travelAgencySelector = buildAuthTravelAgencySelector();
    return (state) => ({
        authTravelAgency: travelAgencySelector(state),
    });
};

export default connect(mapStateToProps)(TravelAgency);
